import { useApp } from "../context/AppContext";
import { Reveal, SectionHead } from "./Reveal";

export const WhyUs = () => {
  const { t } = useApp();
  return (
    <section id="keunggulan" className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-36" data-testid="why-section">
      <SectionHead overline={t.why.overline} title={t.why.title} testId="why-head" />
      <div className="mt-16 md:mt-20">
        {t.why.items.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.05}>
            <div
              data-testid={`why-item-${i}`}
              className="grid grid-cols-12 items-baseline gap-4 border-t border-border py-8 transition-colors duration-300 hover:bg-secondary/40 md:py-10"
            >
              <p className="col-span-12 font-display text-sm font-bold tracking-[0.3em] text-primary md:col-span-2">0{i + 1}</p>
              <h3 className="col-span-12 font-display text-2xl font-medium tracking-tight md:col-span-5 md:text-3xl">{item.title}</h3>
              <p className="col-span-12 leading-relaxed text-muted-foreground md:col-span-5">{item.desc}</p>
            </div>
          </Reveal>
        ))}
        <div className="border-t border-border" />
      </div>
    </section>
  );
};
